import { getJson, postJson } from './client'
import type { ScheduleRun, ScheduleView } from '../types/schedule'

// The automatic scans. There is no setter: the cadence is a deployment choice (a pack seed field),
// so the panel reads it and names the binding rather than offering to change it.
const schedule = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/schedule`

export const scheduleApi = {
  get: (spoke: string) => getJson<ScheduleView>(schedule(spoke)),
  runNow: (spoke: string) => postJson<{ run: ScheduleRun; started: number }>(`${schedule(spoke)}/run`),
}
